export default function AgentSteps({ steps }) {
  if (!steps || steps.length === 0) return null;

  return (
    <div className="bg-gray-900 text-green-400 p-4 rounded-xl mt-6 max-h-96 overflow-y-auto font-mono text-sm shadow-lg">
      
      <h2 className="text-lg mb-3 text-white font-semibold">
        🤖 Agent Thinking
      </h2>

      {steps.map((step, index) => (
        <div key={index} className="mb-4 border-b border-gray-700 pb-2">

          {/* ACTION */}
          {step.type === "action" && (
            <div>
              <p className="text-blue-400 font-semibold">
                ➤ Action: {step.tool}
              </p>

              {/* RAG Highlight */}
              {step.tool === "RAG Context" && (
                <p className="text-purple-400 text-xs">
                  📚 Using RAG Context
                </p>
              )}

              <p className="text-gray-300 text-xs mt-1">
                Input: {step.input}
              </p>
            </div>
          )}

          {/* OBSERVATION */}
          {step.type === "observation" && (
            <div>
              <p className="text-yellow-400 font-semibold">
                ➤ Observation
              </p>
              <p className="text-gray-400 whitespace-pre-wrap text-xs">
                {step.output}
              </p>
            </div>
          )}

          {/* FINAL */}
          {step.type === "final" && (
            <p className="text-green-500 font-bold">
              ✅ Final Answer Ready
            </p>
          )}

        </div>
      ))}

    </div>
  );
}